import { Box, Typography } from "@mui/material";
import useTemplates from "../hooks/use-templates";
import useTemplateAssignment from "../hooks/use-template-assignment";
import useEntities from "../hooks/use-entities";
import FieldTemplatesTable from "./field-templates-table";
import CustomizedAutocomplete from "../../shared/customized-autocomplete";

const TemplateAssignment = () => {
  const { templates } = useTemplates();
  const { entities, isLoading: isLoadingEntities } = useEntities();
  const {
    selectedEntity,
    fieldTemplates,
    isLoading,
    isSaving,
    handleEntityChange,
    handleTemplateChange,
    handleSave,
  } = useTemplateAssignment();

  return (
    <Box>
      <Typography variant="subtitle1" fontWeight={600} gutterBottom>
        Template Assignment
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Assign templates to entity fields for validation and data cleaning.
      </Typography>

      <CustomizedAutocomplete
        value={selectedEntity}
        onChange={handleEntityChange}
        options={entities || []}
        getOptionLabel={(option) => option.description}
        loading={isLoadingEntities}
        label="Select Entity"
        placeholder="Choose an entity..."
        sx={{ mb: 2, maxWidth: "50%" }}
      />

      {selectedEntity && (
        <FieldTemplatesTable
          fieldTemplates={fieldTemplates}
          templates={templates}
          isLoading={isLoading}
          isSaving={isSaving}
          onTemplateChange={handleTemplateChange}
          onSave={handleSave}
        />
      )}
    </Box>
  );
};

export default TemplateAssignment;
